import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, EventEmitter, Input, input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { PortalCollapsibleComponent } from 'app/customer-portal';
import { PortalWidgetDetailsComponent } from 'app/customer-portal/components/portal-widget-details/portal-widget-details.component';

interface TabletForDisplay {
    id: number;
    title: string;
    price: string;
    serialNumber: string;
}

@Component({
    selector: 'app-tablet-plus-insurance-widget-detail',
    templateUrl: './tablet-plus-insurance-widget-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        PortalCollapsibleComponent,
        PortalWidgetDetailsComponent,
        CtrlIconComponent,
        ReactiveFormsModule,
        CommonModule,
    ],
})
export class TabletPlusInsuranceWidgetDetailComponent {
    public tablet = input.required<TabletForDisplay>();

    @Output()
    public onSubmit = new EventEmitter<{ serialNumber: string }>();

    @Input()
    public submitting: boolean;

    protected isComplete = computed(() => !!this.tablet().serialNumber);

    protected formGroup = new FormGroup({
        serialNumber: new FormControl('', { validators: [Validators.required, Validators.minLength(3)] }),
    });

    protected handleSubmit(): void {
        if (this.formGroup.invalid) {
            return;
        }
        this.onSubmit.emit({ serialNumber: this.formGroup.controls.serialNumber.value });
    }
}
